import { render, staticRenderFns } from "./finance-template-widget.vue?vue&type=template&id=85f7d82a&"
import script from "./finance-template-widget.vue?vue&type=script&lang=js&"
export * from "./finance-template-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports